
<abcis-table materProductDt [configuration]="masterTableConfig"
    (onSelectRow)="onRowSelect($event)" (onUnSelectRow)="onRowUnselect($event)">
</abcis-table>
